/* eslint-disable no-undef */
import Modal from 'bootstrap/js/dist/modal'

export default {
  init() {
    // JavaScript to be fired on all pages

    /*
    / Monitor scroll and add classes to body
    */
    const body = document.body
    const scrollUp = 'scroll-up'
    const scrollDown = 'scroll-down'
    let lastScroll = 0

    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset
      if (currentScroll <= 0) {
        body.classList.remove(scrollUp, 'scroll')
        return
      }

      // Once scrolled a little then add
      if (currentScroll >= 400) {
        body.classList.add('scroll')
      }

      if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        // down
        body.classList.remove(scrollUp)
        body.classList.add(scrollDown)
      } else if (
        currentScroll < lastScroll &&
        body.classList.contains(scrollDown)
      ) {
        // up
        body.classList.remove(scrollDown)
        body.classList.add(scrollUp)
      }
      lastScroll = currentScroll
    })

    /**
     * Stop an iframe or HTML5 <video> from playing
     * @param  {Element} element The element that contains the video
     */
    var stopVideo = function (element) {
      var iframe = element.find('iframe')
      var video = element.find('video')

      if (iframe.length) {
        var src = iframe.attr('src')
        iframe.attr('src', src)
      }
      if (video.length) {
        video.each(function () {
          this.pause()
        })
      }
    }

    $('.modal').on('hide.bs.modal', function () {
      var $modal = $($(this))
      stopVideo($modal)
    })

    /*
     * overlay trigger and close
     */
    $(document).on('click', '#search-overlay-trigger', function () {
      var $target = $($(this).data('target'))
      $target.toggleClass('active')
      $(this).toggleClass('active')
    })

    /*
     * Beaver Builder smooth scroll offset
     */
    if ('undefined' != typeof FLBuilderLayoutConfig) {
      FLBuilderLayoutConfig.anchorLinkAnimations.offset = 150
      FLBuilderLayoutConfig.anchorLinkAnimations.duration = 0
    }

    /*
     * Featured Posts slider
     */
    var featuredPosts = document.getElementsByClassName(
      'bb-featured-posts-slide'
    )

    for (var i = 0; i < featuredPosts.length; i++) {
      new Splide(featuredPosts[i], {
        perPage: 1,
        mediaQuery: 'min',
        autoWidth: true,
        padding: 16,
        gap: 16,
        breakpoints: {
          768: {
            perPage: 2,
          },
          992: {
            perPage: 3,
          },
          1200: {
            perPage: 4,
            gap: 32,
          },
        },
      }).mount()
    }

    /*
     * Content Gate
     */

    // Function to check cookie
    function getCookie(cookieName) {
      var name = cookieName + '='
      var decodedCookie = decodeURIComponent(document.cookie)
      var ca = decodedCookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    }

    const myContentGateEl = document.getElementById('contentGate')
    if (myContentGateEl) {
      // Get cookie
      var cookie = getCookie('eventelecGatedContent')

      // If cookie not set then load modal gate
      if (!cookie) {
        // eslint-disable-next-line no-undef
        const myContentGate = new Modal(myContentGateEl, {
          keyboard: false,
        })

        // Show on page load
        myContentGate.show()

        myContentGateEl.addEventListener('hidden.bs.modal', () => {
          // Scroll to top on close
          window.scrollTo(0, 0)
        })
      }
    }

    // Hello Bar Functionality
    function setCookie(cookieName, cookieValue, numdaystilexpireasinteger) {
      var d = new Date()
      d.setTime(d.getTime() + numdaystilexpireasinteger * 24 * 60 * 60 * 1000)
      var expires = 'expires=' + d.toUTCString()
      document.cookie =
        cookieName + '=' + cookieValue + ';' + expires + ';path=/'
      console.log(cookieName)
    }

    function showHello() {
      var currentBarId = $('.hello-bar').attr('id') //get current hello bar id
      var x = getCookie('hello-bar') //call cookie to get its value
      // console.log(x, currentBarId);
      // if current bar id matches current set cookie hide hello bar
      if (x != currentBarId) {
        $('.hello-bar').removeClass('d-none')
      }
    }

    showHello()

    $('.hello-bar .close').on('click', function () {
      setCookie('hello-bar', $('.hello-bar').attr('id'), 7)
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}
